import {
  afterNextRender,
  Component,
  ElementRef,
  inject,
  input,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { gsap } from 'gsap';

@Component({
  selector: 'app-feature-section',
  template: `
    <div
      class="grid grid-cols-1 items-center gap-8 md:grid-cols-2 md:gap-16"
      #container
    >
      <div
        class="relative col-span-1 border-l border-secondary-500 pl-6"
        [ngClass]="{
          'md:order-1': imageFirst(),
        }"
        #body
      >
        <i class="fal fa-shuffle absolute -left-2 -top-8"></i>
        <ng-content select="[body]"></ng-content>
      </div>
      <div class="col-span-1" [ngClass]="{ 'md:order-0': imageFirst() }" #image>
        <ng-content select="[image]"></ng-content>
      </div>
    </div>
  `,
  imports: [NgClass],
})
export class FeatureSectionComponent {
  @ViewChild('container') containerRef: ElementRef;
  @ViewChild('body') bodyRef: ElementRef;
  @ViewChild('image') imageRef: ElementRef;
  platformId = inject(PLATFORM_ID);

  image = input<string>();
  imageFirst = input<boolean>();
  scrollTriggerStart = input<string>('top 65%');

  constructor() {
    afterNextRender(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: this.containerRef.nativeElement,
          start: this.scrollTriggerStart(),
          end: '+=30%',
        },
      });

      let bodyFirst = true;
      if (this.imageFirst()) {
        bodyFirst = false;
      }
      tl.fromTo(
        bodyFirst ? this.bodyRef.nativeElement : this.imageRef.nativeElement,
        { opacity: 0, x: -50 },
        { opacity: 1, x: 0, duration: 0.4, ease: 'power2.easeInOut' },
      );
      tl.fromTo(
        !bodyFirst ? this.bodyRef.nativeElement : this.imageRef.nativeElement,
        { opacity: 0, x: 50 },
        { opacity: 1, x: 0, duration: 0.4, ease: 'power2.easeInOut' },
        '<+=0.3',
      );
    });
  }
}
